<script>
export default {
  name: 'StudioBuy',

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      component: null,
      detail: {}
    }
  },

  computed: {
    // 兼容传递过来的数据 ID 参数
    dataId() {
      return this.$route?.query.dataid ?? this.$route?.query.id;
    },

    // 区分是否是本地录音
    dataType() {
      return this.$route?.query.buy_type === 'local' ? '1' : '0';
    }
  },

  watch: {
    id() {
      this.refresh();
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicStore/musicmall/getSkuInfo', {
        data: {
          skuid: this.id,
          dataid: this.dataId,
          dataType: this.dataType
        }
      });

      this.$toast.clear();

      if (code === 1) {
        if (!data.sku) {
          this.$router.replace('/404');

          return;
        }

        this.detail = data;

        let module = { default: null };
        let pageName;

        try {
          if (this.detail.sku.class_type == 1) {
            pageName = 'remark/pages/Buy';
          }
          else {
            throw '404';
          }

          module = await import(`@cdn_js/studio/flow/${pageName}`);

          this.component = module.default;

          setTimeout(() => {
            this.$children?.[0]?.$refresh();

            try {
              const backgroundColor = window.getComputedStyle(this.$el).getPropertyValue('background-color');
              document.querySelector('html').style.backgroundColor = backgroundColor;
              document.querySelector('body').style.backgroundColor = backgroundColor;
            }
            catch (e) {
            }
          }, 0);

          // 确保清理加载提示
          setTimeout(() => {
            this.$toast.clear();
          }, 50);
        }
        catch (e) {
          this.$router.replace('/404');
        }
      }
    }
  },

  render(createElement) {
    return createElement(this.component, {
      props: {
        id: this.id,
        detail: this.detail
      }
    }, this.$slots.default)
  }
}
</script>
